/*
 * Built with Common Launchpad 2.0.3
 */

import { getField, updateField } from 'vuex-map-fields';
import wqt from '../../api/wqt';

// initial state
const state = {
	currentStep: 0,
	concurrentGuid: '',
	concurrentPostalCode: '',
	resource: 'submitqualifiertool',
	qtResponse: [],
	qualifierToolRequest: {},
	formData: {},
	isLoading: false,
};

// getters
const getters = {
	getField,
};

// actions
const actions = {
	updateStep({ commit, rootState }, step) {
		commit('setStep', step);
	},
	postData({ commit, rootState }, data) {
		// call the api with update specification object
		commit('setQualifierToolRequest', data);		
		wqt.postData(x => {
			commit('setQTResponse', x);		
		}, { data, resource: state.resource });
	},
};

// mutations
const mutations = {
	initData(state, data) {
		state.formData = data;
		mutations.clearLocalStorage();
	},
	setStep(state, step) {
		state.currentStep = step;
		state.isLoading = false;		

		if (step > 11) {
			mutations.clearLocalStorage();
		}
	},
	clearLocalStorage() {
		localStorage.removeItem('CurrentStep');
		localStorage.removeItem('ConcurrentId');
		localStorage.removeItem('ConcurrentZipCode');
	},
	setQualifierToolRequest(state, data) {
		state.qualifierToolRequest = data;		
	},
	setQTResponse(state, data) {
		state.qtResponse = data;		
		state.concurrentGuid = mutations.concurrentIdManager(data);
		state.concurrentPostalCode = localStorage.getItem('ConcurrentZipCode');
	},
	concurrentIdManager(data) {
		let QualifierToolSubmittedGuid = localStorage.getItem('ConcurrentId');
		let guid = '';
		if (QualifierToolSubmittedGuid == null) {
			localStorage.setItem('ConcurrentId', data.QualifierToolSubmittedGuid);
			guid = data.QualifierToolSubmittedGuid;
		} else {
			guid = QualifierToolSubmittedGuid;
		}

		return guid;
	},
	setLoadingState(isLoading) {
		state.isLoading = isLoading;
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
